import React from "react";
// MUI
import { Grid2 } from "@mui/material";
import CheckOutlinedIcon from "@mui/icons-material/CheckOutlined";
// Styling
import styles from "./InstallationType.module.scss";
// Local imports
import {
  installationTypeData,
  installationTypeMap,
} from "../ConstantData/CreateSiteConstantData";
import { buildsV1Sites } from "../../../../../../Utils/roconConstants";

export default function InstallationType(props) {
  const {
    installationType,
    setInstallationType,
    onInstallationTypeSelect,
    dedicatedHosting,
    orgId,
  } = props;
  // New managed sites are EBS (v2) sites, which are single sites only; multisite
  // stays for the orgs that still build v1 sites (never for dedicated hosting)
  const offersMultisite = !dedicatedHosting && buildsV1Sites(orgId);

  const handleInstallationType = (index) => {
    const selectedTitle = installationTypeData[index].title;
    const mappedInstallationType = installationTypeMap[selectedTitle];

    if (installationType === index) {
      setInstallationType(null);
      onInstallationTypeSelect(null);
    } else {
      setInstallationType(index);
      onInstallationTypeSelect(mappedInstallationType);
    }
  };

  return (
    <Grid2 className={styles.InstallationType}>
      <Grid2 className={styles.header}>Select Installation Type</Grid2>
      <Grid2 className={styles.InstallationTypeFlexBox}>
        {installationTypeData
          .filter((item) => {
            if (
              (item.title === "Multisite Sub-domain" ||
                item.title === "Multisite Sub-directory") &&
              !offersMultisite
            ) {
              return false;
            }
            return true;
          })
          .map(({ title, description }, index) => (
            <Grid2
              key={index}
              className={`${styles.Container} ${
                installationType === index ? styles.active : ""
              }`}
              onClick={() => handleInstallationType(index)}
            >
              {installationType === index && (
                <Grid2 className={styles.tickBox}>
                  <CheckOutlinedIcon className={styles.Check} />
                </Grid2>
              )}
              <Grid2>
                <Grid2 className={styles.header}>{title}</Grid2>
                <Grid2 className={styles.subHeader}>{description}</Grid2>
              </Grid2>
            </Grid2>
          ))}
      </Grid2>
    </Grid2>
  );
}
